// src/pages/Publisher/Support/components/SupTableRow.tsx
import React from 'react';
import { SupportTicket } from '../types';
import StatusBadge from '@/components/StatusBadge';
import { formatLocalDate } from '@/utils/FormateLocalDate';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate } from 'react-router-dom';

interface Props {
  ticket: SupportTicket;
  idx: string;
  anchorEl: HTMLElement | null;
  rowIdx: string | null;
  onMenuOpen(e: React.MouseEvent<HTMLElement>, idx: string): void;
  onMenuClose(): void;
  onDelete(idx: string): void;
  onArchive(idx: string): void;
}

const SupTableRow: React.FC<Props> = ({
  ticket,
  idx,
  anchorEl,
  rowIdx,
  onMenuOpen,
  onMenuClose,
  onDelete,
  onArchive,
}) => { 
  const navigate = useNavigate();
  return (
  <tr className='border-b'>
    <td className='p-3'>{formatLocalDate(ticket.created_at)}</td>
    <td className='p-3'>{ticket.id}</td>
    <td className='p-3'>{ticket.issue_tag_name}</td>
    <td className='p-3'>{ticket.description}</td>
    <td className='p-3'>
      <StatusBadge status={ticket.status} />
    </td>
    <td className='p-3 text-left pl-6'>
<button className='' onClick={() => navigate(`/publisher/show-ticket/${ticket.id}`)}>
  <KeyboardArrowRightIcon />
</button>
    </td>
  </tr>
)};

export default SupTableRow;
